import { render } from "./AppHeader.vue?vue&type=template&id=ad046000"
import script from "./AppHeader.vue?vue&type=script&lang=ts"
export * from "./AppHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script